// Created by hejikun on 2017/11/2 0002.
let transfer = [
  // {
  //   path: '/transfer',
  //   name: '双向转诊',
  //   component(resolve) {
  //     require(['@/pages/transfer/index'], resolve)
  //   }
  // }
]

export default transfer
